import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const communityGardenMaterialObject = z.object({
  id: z.string().uuid(),
  communityGardenId: z.string().uuid(),
  materialId: z.string().uuid(),
  quantity: z.number().int().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type CommunityGardenMaterialType = z.infer<typeof communityGardenMaterialObject>

export const propertyMap = {
  id: sql`community_garden_material.id`,
  communityGardenId: sql`community_garden_material.community_garden_id`,
  materialId: sql`community_garden_material.material_id`,
  quantity: sql`community_garden_material.quantity`,
  clientId: sql`community_garden_material.client_id`,
  insertUserId: sql`community_garden_material.insert_user_id`,
  editUserId: sql`community_garden_material.edit_user_id`,
  createdAt: sql`community_garden_material.created_at`,
  updatedAt: sql`community_garden_material.updated_at`,
  deletedAt: sql`community_garden_material.deleted_at`,
}

export default communityGardenMaterialObject
